<!--
 * @Author: Gaho
 * @Date: 2024-03-13 10:10:26
 * @LastEditors: Gaho
 * @LastEditTime: 2025-01-17 16:40:16
 * @Description: 
-->
<template>
        <div class="result-coef">
        <div
            v-for="(v, k) in data"
            :key="k"
            class="result-coef-item"
            :class="
                rollNumber.length &&
                rollNumber.sort((a, b) => a - b).join('') === v.str
                    ? 'win'
                    : !rollNumber.length ? '' : 'normal'
            "
        >
            <div class="item-imgs">
                <img v-for="(_v, _k) in v.str.split('')" :key="_k" :src="getImageUrl(_v)" />
            </div>
            <div class="item-value">x{{ v.odd }}</div>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { type tripleStateTypes } from '../../data/index';
import { getImageUrl } from '../../utils/index';
export default defineComponent({
    name: 'resultCoef',
    props: {
        data: {
            type: Array<tripleStateTypes>,
            default: () => [],
        },
        rollNumber: {
            type: Array<number>,
            default: () => [],
        },
    },
    methods: {
        getImageUrl
    }
});
</script>
<style lang="scss" scoped>
.result-coef {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    z-index: 1;
    user-select: none;
}
</style>